import { ChangeDetectionStrategy, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { Store } from '@ngrx/store';

import { EpcotConfigService } from '../common/epcot-config.service';
import { UiManagerActions } from '../ui-manager/ui-manager.actions';
import { IUiRootState } from '../ui-manager/ui-manager.state';
import { UiStates } from '../ui-manager/ui-states.enum';
import { NumpadInputConnector } from './numpad-input-connector';
import { NumpadService } from './numpad.service';
import { INumpadRootState } from './store/numpad.state';

export enum StakeInputBehavior {
    TypingAndNumpad,
    OnlyTyping,
}

@Component({
    selector: 'ms-stake-input',
    templateUrl: './stake-input.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./stake-input.component.scss'],
    providers: [NumpadInputConnector],
    standalone: false,
})
export class StakeInputComponent implements OnInit, OnDestroy {
    @Input() disabled: boolean;
    @Input() emptyCharacter?: string;
    @Input() adornmentStart?: string;
    @Input() behavior = StakeInputBehavior.TypingAndNumpad;

    @ViewChild('inputRef', { static: true }) inputRef: ElementRef;

    isEpcotEnabled: boolean;

    private get stakeElm(): HTMLInputElement {
        return <HTMLInputElement>this.inputRef.nativeElement;
    }

    constructor(
        public numpadService: NumpadService,
        private store: Store<INumpadRootState & IUiRootState>,
        private epcotConfigService: EpcotConfigService,
        private numpadConnector: NumpadInputConnector,
    ) {
        this.isEpcotEnabled = this.epcotConfigService.isEnabled();
    }

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent): void {
        event.stopPropagation();
        event.preventDefault();

        this.store.dispatch(UiManagerActions.removeState({ state: UiStates.MarketSubTypeTooltipShown }));
    }

    ngOnInit(): void {
        this.numpadConnector.init(this.stakeElm);
    }

    ngOnDestroy(): void {
        this.numpadConnector.deInit();
    }

    onBlur(): void {
        this.numpadConnector.clearFocus();

        if (this.behavior === StakeInputBehavior.OnlyTyping) {
            this.numpadService.confirm();
        }
    }

    onFocus(): void {
        this.numpadConnector.focus();
    }

    onPaste(event: ClipboardEvent): void {
        const text = event.clipboardData?.getData('text');
        if (text) {
            this.numpadService.type(text);
        }
    }

    onKeyUp($event: KeyboardEvent): void {
        const target = $event.target as HTMLInputElement;

        this.numpadService.type(target.value);
    }
}
